import React, { Component } from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const TOOLBAR = {
    options: ['inline', 'fontSize', 'colorPicker', 'link', 'emoji'],
    inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
    },
};

const WRAPPER_STYLE = {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    backgroundColor: '#fff',
};

const EDITOR_STYLE = {
    minHeight: '120px',
    maxHeight: '150px',
    overflowY: 'auto',
    padding: '0 8px',
    order: 1,
};

const TOOLBAR_STYLE = {
    order: 2,
    borderTop: '1px solid #ced4da',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderRadius: '0 0 4px 4px',
    margin: 0,
    padding: '4px 8px',
    backgroundColor: '#f8f9fa',
};

class HtmlEditorInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
        };
        this._lastEmittedHtml = null;
    }

    componentDidMount() {
        this.initEditorFromHtml(this.props.value);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== this._lastEmittedHtml) {
            this.initEditorFromHtml(this.props.value);
        }
    }

    initEditorFromHtml = (html) => {
        if (!html) {
            this.setState({ editorState: EditorState.createEmpty() });
            return;
        }
        const { contentBlocks, entityMap } = htmlToDraft(html);
        const editorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap));
        this.setState({ editorState });
    }

    handleEditorChange = (editorState) => {
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        this._lastEmittedHtml = html;
        this.setState({ editorState });
        this.props.onChange && this.props.onChange(html);
    }

    render() {
        const { disabled } = this.props;
        const { editorState } = this.state;

        return (
            <fieldset disabled={disabled} style={{ border: 'none', padding: 0, margin: 0 }}>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={this.handleEditorChange}
                    toolbar={TOOLBAR}
                    stripPastedStyles={true}
                    wrapperStyle={WRAPPER_STYLE}
                    editorStyle={EDITOR_STYLE}
                    toolbarStyle={TOOLBAR_STYLE}
                />
            </fieldset>
        );
    }
}

export default HtmlEditorInput;
